webpackJsonp([1],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    closeSidebarPanel: __WEBPACK_IMPORTED_MODULE_0__store_store__["b" /* mutations */].toggleNav
  },
  computed: {
    isPanelOpen: function isPanelOpen() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["c" /* store */].isNavOpen;
    }
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      msg: 'Welcome to Wydawnictwo WAM'
    };
  }
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProductView__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductFormSku',

  components: {
    ProductView: __WEBPACK_IMPORTED_MODULE_1__components_ProductView__["a" /* default */]
  },

  data: function data() {
    return {
      scaned: ''
    };
  },
  mounted: function mounted() {
    this.setFocus();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])(['updateScaned']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getProduct']), {
    getInfo: function getInfo($e) {
      this.$store.commit('updateScaned', { scaned: this.scaned });
      this.$store.dispatch('getProduct');
      this.setFocus();
    },
    setFocus: function setFocus() {
      this.scaned = '';
      this.$refs.sku.focus();
      // console.log(this.$refs)
    }
  })
});

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductEditShelf__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SimpleModal__ = __webpack_require__(230);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from 'lodash'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductView',

  components: {
    ProductEditShelf: __WEBPACK_IMPORTED_MODULE_2__components_ProductEditShelf__["a" /* default */],
    SimpleModal: __WEBPACK_IMPORTED_MODULE_3__components_SimpleModal__["a" /* default */]
  },

  data: function data() {
    return {
      showModal: false,
      showSimpleModal: false,
      modalTitle: '',
      modalBody: ''
    };
  },
  created: function created() {},


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])(['product_data', 'magazyn']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['magazynByIm']), {
    magazynSimple: function magazynSimple() {
      var arr = [];
      arr.push(this.magazynByIm('MG'));
      arr.push(this.magazynByIm('MGH'));
      arr.push(this.magazynByIm('MGW'));
      // arr.push(this.magazynByIm('MG+MGW'))
      arr.push(this.magazynByIm('KKH'));
      arr.push(this.magazynByIm('KKW'));
      return arr.filter(function (e) {
        return e;
      });
    },
    generatedData: function generatedData() {
      return this.product_data.generated;
    }
  }),

  methods: {
    strip: function strip(nr) {
      return {
        val: nr.replace(/\.0+/g, '')
      };
    },
    checkStatusModal: function checkStatusModal(value) {
      this.showModal = value[0];
      if (value[1]) {
        value[1].status = true;
        this.showSimpleModal = value[1];
      } else {
        this.$emit('setFocus', true);
      }
    },
    statusSimpleModal: function statusSimpleModal(value) {
      this.showSimpleModal.status = value;
      this.$emit('setFocus', true);
    }
  }
});

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductEditShelf',

  data: function data() {
    return {
      newValue: null
    };
  },
  mounted: function mounted() {
    this.$refs.nw.focus();
  },


  props: ['title', 'currentShelf', 'ipropert'],

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateAdaptixShelf']), {
    closeModal: function closeModal(response) {
      this.$emit('statusModal', [false, response]);
    },
    saveModalShelf: function saveModalShelf(title, newValue, ipropert) {
      var _this = this;

      this.$store.dispatch('updateAdaptixShelf', { title: title, newValue: newValue, ipropert: ipropert }).then(function (response) {
        _this.closeModal(response);
      });
    }
  })
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SimpleModal',

  data: function data() {
    return {};
  },


  props: ['modalTitle', 'modalBody'],

  methods: {
    closeSimpleModal: function closeSimpleModal() {
      this.$emit('statusSimpleModal', false);
    }
  }
});

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProductView__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductFormEan',

  components: {
    ProductView: __WEBPACK_IMPORTED_MODULE_1__components_ProductView__["a" /* default */]
  },

  data: function data() {
    return {
      scaned: ''
    };
  },
  mounted: function mounted() {
    this.setFocus();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])(['updateScaned']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getProduct']), {
    getInfo: function getInfo(e) {
      this.$store.commit('updateScaned', { scaned: this.scaned });
      this.$store.dispatch('getProduct');
      this.setFocus();
    },
    setFocus: function setFocus() {
      this.scaned = '';
      this.$refs.ean.focus();
      // console.log(this.$refs.ean)
    }
  })
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_barcode_reader__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProductView__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(15);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductFormCamera',

  components: {
    ProductView: __WEBPACK_IMPORTED_MODULE_4__components_ProductView__["a" /* default */],
    StreamBarcodeReader: __WEBPACK_IMPORTED_MODULE_3_vue_barcode_reader__["a" /* StreamBarcodeReader */]
  },

  data: function data() {
    return {
      scaned: '',
      isCameraOpen: false
    };
  },
  mounted: function mounted() {
    // this.onDecode('9788375059823')
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])(['updateScaned']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['getProduct']), {
    toggleCamera: function toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
      } else {
        this.isCameraOpen = true;
      }
    },
    onLoaded: function onLoaded() {},
    onDecode: function onDecode(result) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isCameraOpen = false;
                _this.scaned = result;
                _this.$store.commit('updateScaned', { scaned: _this.scaned });
                _this.$store.dispatch('getProduct');

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zxing_library__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "image-barcode-reader",

    data: function data() {
        return {
            codeReader: new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["BrowserMultiFormatReader"]()
        };
    },


    methods: {
        onChangeInput: function onChangeInput(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            var reader = new FileReader();
            reader.onload = this.processFile;
            reader.readAsDataURL(files[0]);
        },
        processFile: function processFile(e) {
            var _this = this;

            this.$el.innerHTML += "<img id=\"image\" src=\"" + e.target.result + "\"/>";

            this.codeReader.decodeFromImage("image").then(function (result) {
                return _this.$emit("decode", result.text);
            }).catch(function (error) {
                return _this.$emit("error", error);
            });
        }
    }
});

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zxing_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zxing_library__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "stream-barcode-reader",

    data: function data() {
        return {
            isLoading: true,
            codeReader: new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["BrowserMultiFormatReader"](),
            isMediaStreamAPISupported: navigator && navigator.mediaDevices && "enumerateDevices" in navigator.mediaDevices
        };
    },
    mounted: function mounted() {
        var _this = this;

        if (!this.isMediaStreamAPISupported) {
            throw new __WEBPACK_IMPORTED_MODULE_0__zxing_library__["Exception"]("Media Stream API is not supported");
            return;
        }

        this.start();
        this.$refs.scanner.oncanplay = function (event) {
            _this.isLoading = false;
            _this.$emit("loaded");
        };
    },
    beforeDestroy: function beforeDestroy() {
        this.codeReader.reset();
    },


    methods: {
        start: function start() {
            var _this2 = this;

            this.codeReader.decodeFromVideoDevice(undefined, this.$refs.scanner, function (result, err) {
                if (result) {
                    _this2.$emit("decode", result.text);
                }
            });
        }
    }
});

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProductsListShelf__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchFormShelf',

  components: {
    ProductsListShelf: __WEBPACK_IMPORTED_MODULE_1__components_ProductsListShelf__["a" /* default */]
  },

  data: function data() {
    return {
      scaned: ''
    };
  },
  mounted: function mounted() {
    // console.log(this)
    this.setFocus();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])(['updateScaned']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['getProductsListByShelf']), {
    getInfo: function getInfo($e) {
      this.updateScaned({ scaned: this.scaned });
      this.getProductsListByShelf();
      this.setFocus();
    },
    setFocus: function setFocus() {
      this.scaned = '';
      this.$refs.shelf.focus();
    }
  })
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { defineComponent } from '@vue/composition-api'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductsListShelf',
  props: {},

  data: function data() {
    return {};
  },


  methods: {
    productsInShelf: function productsInShelf(shelf) {
      var p = this.products_list_shelf;
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(p));
      var pf = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(p).filter(function (key) {
        return [shelf].includes(key);
      }).reduce(function (obj, key) {
        obj = p[key];
        return obj;
      }, {});
      console.log(shelf, pf);
      return pf;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])(['products_list_shelf', 'scaned']), {
    listShelfs: function listShelfs() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.products_list_shelf).length;
    },
    arrayShelfs: function arrayShelfs() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.products_list_shelf);
    }
  })
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_gtag__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_router__ = __webpack_require__(219);







// import AxiosPlugin from 'vue-axios-cors'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_gtag__["a" /* default */], {
  config: {
    id: 'G-QMR0TGM1ZM',
    params: {
      send_page_view: false
    }
  }
}, __WEBPACK_IMPORTED_MODULE_6__router_router__["a" /* default */]);

(function () {
  return new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_6__router_router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
    },
    created: function created() {
      // this.$store.dispatch('getProduct')
    }
  });
})();

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da979eea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da979eea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 147:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Burger_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d6b2da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Burger_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Burger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d6b2da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Burger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_AD; });
/* unused harmony export API_EC */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

// import Vue from 'vue'

var API_AD = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://plan.wydawnictwowam.pl/api',
  auth: { username: 'token', password: 'm2TIVfpgg&PR%kb50^H' },
  withCredentials: true
});

var API_EC = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://wydawnictwowam.pl/json',
  withCredentials: false
});

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.1","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.1","name":"axios","escapedName":"axios","rawSpec":"^0.21.1","saveSpec":null,"fetchSpec":"^0.21.1"},"_requiredBy":["#USER","/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.1","_where":"C:\\Users\\RafałLeśniak\\Projekty\\pwa","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'active' : _vm.isBurgerActive },attrs:{"id":"burger"},on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._m(0)]})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"burger-button",attrs:{"type":"button","title":"Menu"}},[_c('span',{staticClass:"hidden"},[_vm._v("Toggle menu")]),_vm._v(" "),_c('span',{staticClass:"burger-bar burger-bar--1"}),_vm._v(" "),_c('span',{staticClass:"burger-bar burger-bar--2"}),_vm._v(" "),_c('span',{staticClass:"burger-bar burger-bar--3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c1423a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(213);
function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c1423a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.closeSidebarPanel}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-panel"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"sticky"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col main-nav"},[_c('span',{staticClass:"lead"},[_vm._v("Wydawnictwo WAM")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-right loading"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light"})]):_vm._e(),_vm._v(" "),_c('Burger')],1)])])]),_vm._v(" "),_c('Sidebar',[_c('ul',{staticClass:"sidebar-panel-nav"},[_c('li',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/"}},[_c('span',{on:{"click":_vm.toggle}},[_vm._v("Home")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/sku"}},[_c('span',{on:{"click":_vm.toggle}},[_vm._v("SKU")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/ean"}},[_c('span',{on:{"click":_vm.toggle}},[_vm._v("EAN")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/camera"}},[_c('span',{on:{"click":_vm.toggle}},[_vm._v("CAM")])])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/shelf"}},[_c('span',{on:{"click":_vm.toggle}},[_vm._v("SHELF")])])],1)])]),_vm._v(" "),_c('main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(221);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
}));

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProductFormSku__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductFormEan__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductFormCamera__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchFormShelf__ = __webpack_require__(292);






/* harmony default export */ __webpack_exports__["a"] = ([{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */] }, { path: '/sku', name: 'ProductFormSku', component: __WEBPACK_IMPORTED_MODULE_1__components_ProductFormSku__["a" /* default */] }, { path: '/ean', name: 'ProductFormEan', component: __WEBPACK_IMPORTED_MODULE_2__components_ProductFormEan__["a" /* default */] }, { path: '/camera', name: 'ProductFormCamera', component: __WEBPACK_IMPORTED_MODULE_3__components_ProductFormCamera__["a" /* default */] }, { path: '/shelf', name: 'SearchFormShelf', component: __WEBPACK_IMPORTED_MODULE_4__components_SearchFormShelf__["a" /* default */] }]);

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b5e65c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(223);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b5e65c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFormSku_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7648fefc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFormSku_vue__ = __webpack_require__(234);
function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7648fefc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFormSku_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7648fefc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFormSku_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 225:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEditShelf_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a77a076_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEditShelf_vue__ = __webpack_require__(229);
function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a77a076"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEditShelf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a77a076_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEditShelf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 228:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"modal","id":"editModal","tabindex":"-1","aria-labelledby":"editModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"editModalLabel"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col col-form-label",attrs:{"for":"cW"}},[_vm._v("Current value:")]),_vm._v(" "),_c('div',{staticClass:"col col-form-label"},[_c('div',{attrs:{"id":"cW"}},[_c('strong',[_vm._v(_vm._s(_vm.currentShelf))])])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col col-form-label",attrs:{"for":"nW"}},[_vm._v("New value:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],ref:"nw",staticClass:"col form-control form-control-lg",attrs:{"type":"text","id":"nW","placeholder":"","autocomplete":"off"},domProps:{"value":(_vm.newValue)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.saveModalShelf(_vm.title, _vm.newValue, _vm.ipropert)},"input":function($event){if($event.target.composing){ return; }_vm.newValue=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveModalShelf(_vm.title, _vm.newValue, _vm.ipropert)}}},[_vm._v("Save changes")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleModal_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e114806_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleModal_vue__ = __webpack_require__(232);
function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e114806"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e114806_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"simpleModal",staticClass:"modal modal-mask",staticStyle:{"display":"block"},attrs:{"name":"modal","id":"simpleModal","tabindex":"-1","aria-labelledby":"simpleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.modalTitle))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeSimpleModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.modalBody))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.closeSimpleModal()}}},[_vm._v("Close")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product_data.generated)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.product_data.generated.tytul)?_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.product_data.generated.tytul))]):_c('h4',[_vm._v(_vm._s(_vm.product_data.generated.tytul_magazynowy))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.product_data.generated.podtytul))]),_vm._v(" "),_c('div',{staticClass:"text-center my-1"},[_c('div',{staticClass:"my-1 w-100 btn btn-lg btn-success",attrs:{"data-toggle":"modal","data-target":"#editModal"},on:{"click":function($event){_vm.showModal = true, _vm.title='Półka 3 - magazyn podręczny', _vm.ipropert='półka3', _vm.currentShelf=_vm.generatedData.półka3}}},[_c('span',{staticClass:"float-left text-uppercase"},[_vm._v("MG podręczny")]),_vm._v(" "),_c('span',{staticClass:"float-right font-weight-bold"},[_vm._v(_vm._s(_vm.generatedData.półka3))])]),_vm._v(" "),_c('div',{staticClass:"my-1 w-100 btn btn-lg btn-warning",attrs:{"data-toggle":"modal","data-target":"#editModal"},on:{"click":function($event){_vm.showModal = true, _vm.title='Półka 1 - magazyn główny', _vm.ipropert='pólka1', _vm.currentShelf=_vm.generatedData.pólka1}}},[_c('span',{staticClass:"float-left text-uppercase"},[_vm._v("MG główny")]),_vm._v(" "),_c('span',{staticClass:"float-right font-weight-bold"},[_vm._v(_vm._s(_vm.generatedData.pólka1))])]),_vm._v(" "),_c('div',{staticClass:"my-1 w-100 btn btn-lg btn-danger",attrs:{"data-toggle":"modal","data-target":"#editModal"},on:{"click":function($event){_vm.showModal = true, _vm.title='Regał 3 - magazyn MGH', _vm.ipropert='regał3', _vm.currentShelf=_vm.generatedData.regał3}}},[_c('span',{staticClass:"float-left text-uppercase"},[_vm._v("MG  MGH")]),_vm._v(" "),_c('span',{staticClass:"float-right font-weight-bold"},[_vm._v(_vm._s(_vm.generatedData.regał3))])]),_vm._v(" "),_c('div',{staticClass:"my-1 w-100 btn btn-lg btn-dark",attrs:{"data-toggle":"modal","data-target":"#editModal"},on:{"click":function($event){_vm.showModal = true, _vm.title='Regał - regał księgarnia', _vm.ipropert='regał', _vm.currentShelf=_vm.generatedData.regał}}},[_c('span',{staticClass:"float-left text-uppercase"},[_vm._v("regał")]),_vm._v(" "),_c('span',{staticClass:"float-right font-weight-bold"},[_vm._v(_vm._s(_vm.generatedData.regał))])]),_vm._v(" "),_c('div',{staticClass:"my-1 w-100 btn btn-lg btn-primary",attrs:{"data-toggle":"modal","data-target":"#editModal"},on:{"click":function($event){_vm.showModal = true, _vm.title='Regał 2 - magazyn księgarnia', _vm.ipropert='regał2', _vm.currentShelf=_vm.generatedData.regał2}}},[_c('span',{staticClass:"float-left text-uppercase"},[_vm._v("regał 2")]),_vm._v(" "),_c('span',{staticClass:"float-right font-weight-bold"},[_vm._v(_vm._s(_vm.generatedData.regał2))])])]),_vm._v(" "),(_vm.showModal)?_c('ProductEditShelf',{attrs:{"showModal":_vm.showModal,"title":_vm.title,"ipropert":_vm.ipropert,"currentShelf":_vm.currentShelf},on:{"statusModal":_vm.checkStatusModal}}):_vm._e(),_vm._v(" "),(_vm.showSimpleModal.status)?_c('SimpleModal',{attrs:{"modalTitle":_vm.showSimpleModal.emessage,"modalBody":_vm.showSimpleModal.detail},on:{"statusSimpleModal":_vm.statusSimpleModal}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"my-1"},[_c('img',{staticClass:"img-fluid w-100",attrs:{"src":_vm.generatedData.okladka_sklep}})]),_vm._v(" "),_c('table',{staticClass:"table my-1 w-100 r_center table-dark"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.magazynSimple),function(mg){return _c('tr',{key:mg.imagazyn},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(mg.imagazyn))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.strip(mg.stan).val))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.strip(mg.zostalo).val))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"my-1 w-100 r_center"},[(_vm.generatedData.cena_okladkowa)?_c('div',{staticClass:"clearfix"},[_c('span',{staticClass:"float-left"},[_vm._v("cena katalogowa")]),_vm._v(" "),_c('span',{staticClass:"float-right font-weight-bold"},[_vm._v(_vm._s(_vm.generatedData.cena_okladkowa))])]):_vm._e()])],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left",attrs:{"scope":"col"}},[_vm._v("Magazyn")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"scope":"col"}},[_vm._v("Stan")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Zostało")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scaned),expression:"scaned"}],ref:"sku",staticClass:"form-control",attrs:{"type":"text","autofocus":"","placeholder":"input SKU code","aria-label":"SKU","aria-describedby":"button-addon2"},domProps:{"value":(_vm.scaned)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return _vm.getInfo($event)},"input":function($event){if($event.target.composing){ return; }_vm.scaned=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","id":"button-addon2"},on:{"click":function($event){return _vm.getInfo($event)}}},[_vm._v("Get product")])])])])]),_vm._v(" "),_c('ProductView',{on:{"setFocus":function($event){return _vm.setFocus()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFormEan_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6e1012c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFormEan_vue__ = __webpack_require__(237);
function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6e1012c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFormEan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6e1012c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFormEan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scaned),expression:"scaned"}],ref:"ean",staticClass:"form-control",attrs:{"type":"text","autofocus":"","placeholder":"input EAN code","aria-label":"EAN","aria-describedby":"button-addon2"},domProps:{"value":(_vm.scaned)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return _vm.getInfo($event)},"input":function($event){if($event.target.composing){ return; }_vm.scaned=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","id":"button-addon2"},on:{"click":function($event){return _vm.getInfo($event)}}},[_vm._v("Get product")])])])])]),_vm._v(" "),_c('ProductView',{on:{"setFocus":function($event){return _vm.setFocus()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFormCamera_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9cf467_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFormCamera_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e9cf467"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFormCamera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9cf467_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFormCamera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageBarcodeReader_vue__ = __webpack_require__(113);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a9bff776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageBarcodeReader_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ImageBarcodeReader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a9bff776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ImageBarcodeReader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() { return CustomError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customErrorFactory", function() { return customErrorFactory; });
function fixProto(target, prototype) {
  var setPrototypeOf = Object.setPrototypeOf;
  setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function fixStack(target, fn) {
  if (fn === void 0) {
    fn = target.constructor;
  }

  var captureStackTrace = Error.captureStackTrace;
  captureStackTrace && captureStackTrace(target, fn);
}

var __extends = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var CustomError = function (_super) {
  __extends(CustomError, _super);

  function CustomError(message, options) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message, options) || this;

    Object.defineProperty(_this, 'name', {
      value: _newTarget.name,
      enumerable: false,
      configurable: true
    });
    fixProto(_this, _newTarget.prototype);
    fixStack(_this);
    return _this;
  }

  return CustomError;
}(Error);

var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
function customErrorFactory(fn, parent) {
  if (parent === void 0) {
    parent = Error;
  }

  function CustomError() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (!(this instanceof CustomError)) return new (CustomError.bind.apply(CustomError, __spreadArray([void 0], args, false)))();
    parent.apply(this, args);
    Object.defineProperty(this, 'name', {
      value: fn.name || parent.name,
      enumerable: false,
      configurable: true
    });
    fn.apply(this, args);
    fixStack(this, CustomError);
  }

  return Object.defineProperties(CustomError, {
    prototype: {
      value: Object.create(parent.prototype, {
        constructor: {
          value: CustomError,
          writable: true,
          configurable: true
        }
      })
    }
  });
}


//# sourceMappingURL=custom-error.mjs.map


/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","name":"image","accept":"image/*","capture":"environment"},on:{"change":_vm.onChangeInput}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StreamBarcodeReader_vue__ = __webpack_require__(140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eee31630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_StreamBarcodeReader_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eee31630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StreamBarcodeReader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eee31630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_StreamBarcodeReader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scanner-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]},[_c('video',{ref:"scanner",attrs:{"poster":"data:image/gif,AAAA"}}),_vm._v(" "),_c('div',{staticClass:"overlay-element"}),_vm._v(" "),_c('div',{staticClass:"laser"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('div',{staticClass:"my-2"},[(!_vm.isCameraOpen)?_c('button',{staticClass:"btn btn-lg btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggleCamera}},[_vm._v("Open Scanner")]):_c('button',{staticClass:"btn btn-lg btn-secondary",attrs:{"type":"button"},on:{"click":_vm.toggleCamera}},[_vm._v("Close Scanner")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[(_vm.isCameraOpen)?_c('StreamBarcodeReader',{staticClass:"my-2",on:{"loaded":_vm.onLoaded,"decode":_vm.onDecode}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[(_vm.scaned)?_c('div',{staticClass:"my-2"},[_c('span',{staticClass:"text-success"},[_vm._v("ean:")]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.scaned)+" ")])]):_vm._e()])]),_vm._v(" "),_c('ProductView',{on:{"setFocus":function($event){return _vm.setFocus()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFormShelf_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e421b5e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFormShelf_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e421b5e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFormShelf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e421b5e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFormShelf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsListShelf_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5f5da10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsListShelf_vue__ = __webpack_require__(300);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5f5da10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsListShelf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5f5da10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsListShelf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listShelfs)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},_vm._l((_vm.arrayShelfs),function(shelf){return _c('table',{key:shelf,staticClass:"table table-dark table-striped"},[_c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.scaned))]),_vm._v(" - "+_vm._s(shelf))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.productsInShelf(shelf)),function(products){return _c('tr',{key:products.nazwa},[_c('td',[_vm._v(_vm._s(products.nazwa))])])}),0)])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scaned),expression:"scaned"}],ref:"shelf",staticClass:"form-control",attrs:{"type":"text","autofocus":"","placeholder":"input the shelf code","aria-label":"SHELF","aria-describedby":"button-addon2"},domProps:{"value":(_vm.scaned)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return _vm.getInfo($event)},"input":function($event){if($event.target.composing){ return; }_vm.scaned=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","id":"button-addon2"},on:{"click":function($event){return _vm.getInfo($event)}}},[_vm._v("Get code")])])])])]),_vm._v(" "),_c('ProductsListShelf',{on:{"setFocus":function($event){return _vm.setFocus()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__(191);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].observable({
  isNavOpen: false
});

var mutations = {
  setIsNavOpe: function setIsNavOpe(yesno) {
    store.isNavOpen = yesno;
  },
  toggleNav: function toggleNav() {
    store.isNavOpen = !store.isNavOpen;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: true,

  state: {
    product_data: [],
    products_list_shelf: [],
    magazyn: [],
    loading: false,
    scaned: ''
  },

  getters: {
    magazynByIm: function magazynByIm(state) {
      return function (imagazyn) {
        return state.magazyn.find(function (arr) {
          return arr.imagazyn === imagazyn;
        });
      };
    }
  },

  actions: {
    getProduct: function getProduct(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('changeLoadingState', true);
      __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* API_AD */].get('global_get_product_info_by_sku/' + this.state.scaned, { withCredentials: true }).then(function (response) {
        commit('updateProduct', response.data);
      }, function (error) {
        console.log(error);
      }).finally(function () {
        dispatch('prepareMagazyn');
        commit('changeLoadingState', false);
      });
    },
    getProductsListByShelf: function getProductsListByShelf(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit('changeLoadingState', true);
      __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* API_AD */].get('adaptix_get_products_list_by_shelf/' + this.state.scaned, { withCredentials: false }).then(function (response) {
        commit('updateProductsListByShelf', response.data);
      }, function (error) {
        console.log(error);
      }).finally(function () {
        commit('changeLoadingState', false);
      });
    },
    prepareMagazyn: function prepareMagazyn(_ref3) {
      var commit = _ref3.commit;

      var stany = this.state.product_data.data.soap_adaptix.Vindeks_data.Vstan_magazynu;
      var stanyNull = {
        imagazyn: '',
        stan: '0',
        zostalo: '0'
      };
      var stanyMg = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(stany, { imagazyn: 'MG' }) || stanyNull;
      var stanyMgw = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(stany, { imagazyn: 'MGW' }) || stanyNull;
      var stanyAdd = {
        imagazyn: 'MG+MGW',
        stan: String(Number(stanyMg.stan) + Number(stanyMgw.stan)),
        zostalo: String(Number(stanyMg.zostalo) + Number(stanyMgw.zostalo))
        // console.log(stanyAdd)
      };if (Array.isArray(stany) === true) {} else {
        stany = [stany];
      }
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(stany, { imagazyn: 'MG' }) && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(stany, { imagazyn: 'MGW' })) {
        stany.push(stanyAdd);
      }
      stany = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(stany, ['imagazyn']);
      commit('updateMagazyn', stany);
    },
    updateAdaptixShelf: function updateAdaptixShelf(context, payload) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        context.commit('changeLoadingState', true);
        var iindeksy = _this.state.product_data.data.soap_adaptix.Vindeks_data.iindeksy;
        var vpropertUpdate = { 'ipropert': payload.ipropert, 'ipropers': payload.newValue };
        var postData = {
          'iindeksy': iindeksy,
          'Vpropert_update': vpropertUpdate
        };
        var headers = {
          // 'Content-Type': 'application/x-www-form-urlencoded'
          // 'Content-Type': 'application/json'
        };
        __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* API_AD */].post('aw_indeks_update', postData, { headers: headers }).then(function (res) {
          // console.log(res.data)
          _this.emessage = res.data.answer.emessage || 'ERROR';
          _this.detail = res.data.answer.detail || 'Success';
          _this.detail = _this.detail.errormessage || 'Success';
        }).finally(function () {
          if (_this.emessage === 'OK') {
            context.commit('updateShelf', postData);
          }
          resolve({ 'emessage': _this.emessage, 'detail': _this.detail });
          context.commit('changeLoadingState', false);
        });
      });
    }
  },

  mutations: {
    updateProduct: function updateProduct(state, payLoad) {
      state.product_data = payLoad;
    },
    updateProductsListByShelf: function updateProductsListByShelf(state, payLoad) {
      state.products_list_shelf = payLoad.data;
    },
    changeLoadingState: function changeLoadingState(state, status) {
      state.loading = status;
    },
    updateScaned: function updateScaned(state, payLoad) {
      state.scaned = payLoad.scaned;
    },
    updateMagazyn: function updateMagazyn(state, payLoad) {
      state.magazyn = payLoad;
    },
    updateShelf: function updateShelf(state, payLoad) {
      var ipropert = payLoad.Vpropert_update.ipropert;
      var ipropers = payLoad.Vpropert_update.ipropers;
      switch (ipropert) {
        case 'pólka1':
          state.product_data.generated.pólka1 = ipropers;
          break;
        case 'półka3':
          state.product_data.generated.półka3 = ipropers;
          break;
        case 'regał':
          state.product_data.generated.regał = ipropers;
          break;
        case 'regał2':
          state.product_data.generated.regał2 = ipropers;
          break;
        case 'regał3':
          state.product_data.generated.regał3 = ipropers;
          break;
      }
    }
  },

  modules: {}
}));

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductView_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9036b7fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductView_vue__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9036b7fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9036b7fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu_Burger__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Menu_Sidebar__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store_js__ = __webpack_require__(44);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Burger: __WEBPACK_IMPORTED_MODULE_2__components_Menu_Burger__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__components_Menu_Sidebar__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])(['loading'])),
  methods: {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_4__store_store_js__["b" /* mutations */].toggleNav();
    },
    convMagazyn: function convMagazyn() {
      console.log('xxx');
    }
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  // data: () => ({
  //     isBurgerActive: false
  // }),
  computed: {
    isBurgerActive: function isBurgerActive() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["c" /* store */].isNavOpen;
    }
  },
  methods: {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_0__store_store__["b" /* mutations */].toggleNav();
    }
  }
});

/***/ })

},[143]);


// WEBPACK FOOTER //
// static/js/app.e077fe21e8d492af130f.js